export const extractTags = (text: string) => {
  const tags = [...text.matchAll(/<tag>(.*?)<\/tag>/g)].map(m => m[1]);

  const contentWithoutTags = text.replace(/<tag>.*?<\/tag>/g, '').trim();

  return { tags, contentWithoutTags };
};

export function slugifyCompanyName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/gi, 'd')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
